import { render } from "./Tabs.vue?vue&type=template&id=3d492e88&scoped=true"
import script from "./Tabs.vue?vue&type=script&lang=js"
export * from "./Tabs.vue?vue&type=script&lang=js"

import "./Tabs.vue?vue&type=style&index=0&id=3d492e88&lang=scss"
import "./Tabs.vue?vue&type=style&index=1&id=3d492e88&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d492e88"]])

export default __exports__